<template>
    <div></div>
</template>
<script>
import { socketManagerInit,userOutline } from '../util/SocketManager.js'
import { mapState, mapMutations } from "vuex";
export default {
    data() {
        return {
            pageName: "aizw",//zy sw,
        };
    },
    methods: {
        initSocket() {
            let imPath = "znzt_socket.io"
            let localUrl = window.location.origin;
            if (localUrl.indexOf("localhost") > -1) {
                localUrl = "http://10.31.65.200"
            }
            let userInfo = {
                userId: this.userInfo.userId,
                userName: this.userInfo.userName,
                realName: this.userInfo.realName,
                photo: this.userInfo.photo,
                device: "web",
                deviceToken: this.userInfo.accessToken,
                pageName: "nz_aizw"
            }
            const callBack = () =>{}
            socketManagerInit(localUrl, imPath, callBack, this.pageName, JSON.stringify(userInfo));
        },
    },

    computed: {
        ...mapState(["socketConnectOnOutline", 'userInfo']),
    },
    watch: {
        socketConnectOnOutline(newVal, oldVal) {
            if (newVal) {
                this.initSocket();
            } else {
                let userInfo = {
                    userId: this.userInfo.userId,
                    userName: this.userInfo.userName,
                    realName: this.userInfo.realName,
                    photo: this.userInfo.photo,
                    device: "web",
                    deviceToken: this.userInfo.accessToken

                }
                userOutline(JSON.stringify(userInfo))
            }
        },
    },
};
</script>